import { render, staticRenderFns } from "./ChatArea.vue?vue&type=template&id=5fa135bb&"
import script from "./ChatArea.vue?vue&type=script&lang=js&"
export * from "./ChatArea.vue?vue&type=script&lang=js&"
import style0 from "./ChatArea.vue?vue&type=style&index=0&id=5fa135bb&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports